import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data is considered fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      // Cache data for 10 minutes after it becomes unused
      cacheTime: 10 * 60 * 1000,
      // Retry failed requests 2 times
      retry: 2,
      // Don't refetch on window focus (to prevent unnecessary requests)
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect (WebSocket handles real-time updates)
      refetchOnReconnect: false,
      // Don't refetch on mount if data is fresh
      refetchOnMount: false,
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

// Validation: Ensure QueryClient is properly initialized
if (!queryClient) {
  throw new Error(
    'QueryClient failed to initialize. ' +
    'Please check React Query installation and ensure @tanstack/react-query is properly installed.'
  );
}

// Development: Log QueryClient initialization for debugging
if (process.env.NODE_ENV === 'development') {
  console.log('✅ QueryClient initialized successfully');
  console.log('📦 QueryClient instance:', queryClient);
}

export default queryClient;

